import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import registerIcon1 from 'assets/img/ico_registration_01.png';
import registerIcon2 from 'assets/img/ico_registration_02.png';
import registerIcon3 from 'assets/img/ico_registration_03.png';
import './register.scss';

//own components
import Head from 'components/metatags_helmet/metatags';
import RegisterComp from 'components/register/RegisterComp';
import TitleWithLine from 'components/titleWithLine';

const Register = () => {
  const { t } = useTranslation(['register']);

  useEffect(() => {
    goUp();
  }, []);

  const goUp = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="container-fluid mainDiv">
      <Head title={t('register')} noIndex={true} />
      <Row className="justify-content-center mainRow register mx-1">
        <Col lg={8}>
          <div className="row">
            <div className="col-md-12">
              <TitleWithLine text={t('freeregister')} />
            </div>
          </div>
          <p>
            {t('markedfields')} <span className="orange"> * </span> {t('obligatoryfields')}
          </p>
          <RegisterComp />
          <p>{t('information')}</p>
        </Col>
        <Col className="border asideCol" lg={4}>
          <Row>
            <Col className="mt-4" lg={12}>
              <img src={registerIcon1} alt="icon.png" />
              <p className="mt-2">{t('bookstoresroles')}</p>
            </Col>
          </Row>
          <Row>
            <Col className="mt-4" lg={12}>
              <img src={registerIcon2} alt="icon.png" />
              <p className="mt-2">{t('definitionlibelist')}</p>
            </Col>
          </Row>
          <Row>
            <Col className="mt-4 mb-5" lg={12}>
              <img src={registerIcon3} alt="icon.png" />
              <p className="mt-2">{t('benefitlibelist')}</p>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Register;
